import { mapState } from 'vuex';
import * as firebase from '@/firebase';
import UserTypesEnum from '@/enums/userTypes';

export default {
  computed: {
    ...mapState(['global', 'settings']),

    authenticated() {
      return firebase.auth.currentUser;
    },

    user() {
      return this.global.currentUser;
    },

    company() {
      return this.global.company;
    },

    fullName() {
      return `${this.user.first_name} ${this.user.last_name}`;
    },

    userType() {
      return UserTypesEnum.getValue(this.user.type);
    },

    isAdmin() {
      return this.user.type === 1;
    },

    isManager() {
      return this.user.type === 2;
    },

    isBroker() {
      return this.user.type === 3;
    },

    isEmployee() {
      return this.user.type === 4;
    },
  },
};
